import { ControllerRenderProps } from 'react-hook-form'

import { TCommonFields } from '../../types'
import { FileFieldRow, FileInput } from './file-input'

export type TFileField<T> = TCommonFields<T> & {
    type: 'file'
    props?: Record<string, any>
}

type TFileFieldProps<T> = {
    field: ControllerRenderProps<any, string>
    field_: TFileField<T>
    required: boolean
    disabled: boolean
    /** @deprecated the stored file name is taken from the form value */
    item?: string
}

export const FileField = <T,>({ field, field_, required, disabled }: TFileFieldProps<T>) => (
    <FileInput field={field} rowField={field_} required={required} disabled={disabled} />
)

type TProps<T> = {
    rowField: TFileField<T>
    fieldName: string
    labelWidth?: string
    /** @deprecated the stored file name is taken from the form value */
    fieldItem?: string
}

const FileFieldDefault = <T,>({ fieldName, rowField, labelWidth }: TProps<T>) => (
    <FileFieldRow fieldName={fieldName} rowField={rowField} labelWidth={labelWidth} />
)

export default FileFieldDefault
